import React from 'react';
import {
  Stethoscope, Users, GitBranch, Pill, Clock, CalendarDays, CalendarCheck,
} from 'lucide-react';

const TILES = [
  { key: 'visits', label: 'Patient visits', icon: Stethoscope },
  { key: 'unique_patients', label: 'Unique patients', icon: Users },
  { key: 'referrals', label: 'Referrals', icon: GitBranch },
  { key: 'rx_lines', label: 'Rx lines', icon: Pill },
  { key: 'hours_rostered', label: 'Hours rostered', icon: Clock },
  { key: 'days_rostered', label: 'Days on duty', icon: CalendarDays },
  { key: 'appointments_today', label: "Today's queue", icon: CalendarCheck },
];

/** Activity KPI tiles for staff profile. */
export default function StaffProfileStats({ summary }) {
  const s = summary || {};
  const days = s.period_days || 90;
  return (
    <section data-testid="staff-profile-stats">
      <div className="flex items-baseline justify-between mb-3">
        <h3 className="text-sm font-semibold text-zinc-900">Activity summary</h3>
        <span className="text-[11px] text-zinc-500">Last {days} days</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {TILES.map(({ key, label, icon: Icon }) => (
          <div key={key} className="rounded-xl border bg-white p-3 shadow-sm">
            <div className="flex items-center gap-2 text-zinc-500 mb-2">
              <Icon className="h-3.5 w-3.5" />
              <span className="text-[10px] uppercase tracking-wide font-medium">{label}</span>
            </div>
            <p className="text-xl font-semibold text-zinc-900 tabular-nums">
              {s[key] ?? 0}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
